module.exports = __webpack_public_path__ + "static/media/09-01.e5b87f2f.png";